import Vue from 'vue';
import Router from 'vue-router';
// // https://github.com/declandewet/vue-meta
// import VueMeta from 'vue-meta'
// // Adds a loading bar at the top during page loads.
// import NProgress from 'nprogress/nprogress'
import store from '../../store';

import routes from './routes-mc';

Vue.use(Router);

const router = new Router({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  function redirectToLogin() {
    // Pass the original route to the login component
    if (routeTo.name === 'home') {
      next({ name: 'login' });
    } else {
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    }
  }

  function redirectToPasswordRenewal() {
    next({ name: 'password-renewal' });
  }

  function proceed() {
    if (routeTo.name === 'home') {
      return next({ name: 'business-days' });
    }
    return next();
  }

  // // If this isn't an initial page load...
  // if (routeFrom.name) {
  //   // Start the route progress bar.
  //   NProgress.start()
  // }

  // Check if auth is required on this route
  const authRequired = !['password-recovery', 'register', 'login'].includes(routeTo.name);
  const passwordExpired = store.getters.isPasswordExpired;

  // If auth isn't required for the route, just continue.
  if (!authRequired) {
    return proceed();
  }

  if (routeTo.name === 'password-renewal') {
    if (passwordExpired) {
      // Avoid infinite loop
      return next();
    }
    // Already renewed
    return next({ name: 'home' });
  }

  // If auth is required and the customer is logged in...
  if (store.getters.isAuthenticated) {
    if (passwordExpired) {
      return redirectToPasswordRenewal();
    }
    return proceed();
  }

  store.dispatch('tryAutoLogin');
  if (store.getters.isAuthenticated) {
    if (passwordExpired) {
      return redirectToPasswordRenewal();
    }
    return proceed();
  }

  // If auth is required and the customer is NOT currently logged in,
  // redirect to login.
  return redirectToLogin();
});

// // When each route is finished evaluating...
// router.afterEach((routeTo, routeFrom) => {
//   // Complete the animation of the route progress bar.
//   NProgress.done()
// })

export default router;



// WEBPACK FOOTER //
// ./src/mc/router/index.js